<ng-container [ngSwitch]="getLabelType()">
  <div *ngSwitchCase="'circle'" class="circle-label" [style.background-color]="getCircleBackgroundColor()" [style.border-color]="getCircleBorderColor()">
    {{getValue()}}
  </div>
  <div *ngSwitchCase="'header'" class="form-group header-label" [class]="getOptionByKey(attribute,'style-class')" [innerHTML]="getValue()"></div>
  <div *ngSwitchCase="'boldtitle'" class="form-group bold-title-label" [class]="getOptionByKey(attribute,'style-class')" [innerHTML]="getValue()"></div>
  <div *ngSwitchDefault class="form-group" [class]="getOptionByKey(attribute,'style-class')" [class.highlighted-text]="showHeaderType()" [innerHTML]="getValue()"></div>
</ng-container>
